import { postData } from "@/services/apiService";
import { descriptografarObjetoSession } from "@/utils/encryptedStorage.js";

let logsHistorico = [];
let sequenciaOperacao = 0;
let sessaoIniciada = null;
let geraLogsAtivo = false;
let pedidoFinal = null;

let dadosSessao = {
  vendedor_id: null,
  usuario_id: null,
  vendedor_nome: null,
  inicio_sessao: null,
  filtros_produto: {},
  configuracoes: {
    pedido_rapido: false,
    historico_pedido_rapido: [],
  },
};

export function setGeraLogs(value) {
  geraLogsAtivo = String(value).toLowerCase() === "true";
}

export function setPedidoRapido(ativado) {
  if (!geraLogsAtivo) return;
  const estadoAnterior = dadosSessao.configuracoes.pedido_rapido;
  dadosSessao.configuracoes.pedido_rapido = ativado;

  dadosSessao.configuracoes.historico_pedido_rapido.push({
    timestamp: getTimestampDetalhado(),
    ativado: ativado,
  });

  if (geraLogsAtivo && estadoAnterior !== ativado) {
    logAcaoUsuario("ALTERAR_PEDIDO_RAPIDO", {
      estado_anterior: estadoAnterior,
      estado_novo: ativado,
      timestamp: getTimestampDetalhado(),
    });
  }
}

export function getPedidoRapido() {
  return dadosSessao.configuracoes.pedido_rapido;
}

function getTimestamp() {
  const now = new Date();
  return now.toLocaleDateString("pt-BR") + " " + now.toLocaleTimeString("pt-BR", { hour12: false });
}

function getTimestampDetalhado() {
  return new Date().toISOString();
}

function formatarMoeda(valor) {
  return parseFloat(valor || 0).toFixed(2);
}

function calcularTotaisPedido(pedido) {
  const itens = pedido.itens_pedido || [];
  const totalPedido = itens.reduce((t, i) => t + i.preco * i.quantidade, 0);
  const totalAjuste = itens.reduce((t, i) => t + (i.ajuste_item || 0), 0);

  return {
    total_pedido: formatarMoeda(totalPedido),
    total_ajuste: formatarMoeda(totalAjuste),
    total_liquido: formatarMoeda(totalPedido + totalAjuste),
    quantidade_total_itens: itens.reduce((t, i) => t + i.quantidade, 0),
  };
}

export function capturarEstadoPedido(pedido) {
  const totais = calcularTotaisPedido(pedido);
  pedidoFinal = {
    pedido_id: pedido.id ? parseInt(pedido.id) : null,
    vendedor: pedido.nome_vendedor || dadosSessao.vendedor_nome,
    totais,
    total_itens: pedido.itens_pedido ? pedido.itens_pedido.length : 0,
    sequencia: "FINAL",
    dados: {
      cliente: pedido.id_cliente + " - " + pedido.nome_cliente,
      plano_pagamento: pedido.id_plano_pagto + " - " + pedido.nome_plano_pagto || null,
      franqueado: pedido.id_franqueado + " - " + pedido.nome_franqueado || null,
      tabela_preco: pedido.id_tabela_precos + " - " + pedido.nome_tabela_precos || null,
      forma_pagamento: pedido.id_forma_pagto + " - " + pedido.nome_forma_pagto || null,
      data_prevista: pedido.dataPrevista || null,
    },
    itens: pedido.itens_pedido
      ? pedido.itens_pedido.map((item, idx) => ({
          index: idx,
          id: item.id,
          nome: item.nome,
          quantidade: item.quantidade,
          preco: item.preco,
          preco_tabela: item.preco_tabela,
          preco_minimo: item.preco_minimo,
          preco_maximo: item.preco_maximo,
          ajuste_item: item.ajuste_item,
          ajuste_percentual: item.ajuste_percentual,
          mercOuServ: item.mercOuServ,
          valor_total: formatarMoeda(item.preco * item.quantidade),
        }))
      : [],
  };
  return pedidoFinal;
}

export async function iniciarSessaoLog() {
  if (!geraLogsAtivo) return;
  if (sessaoIniciada) return;
  sessaoIniciada = getTimestampDetalhado();

  const vendedorId = await descriptografarObjetoSession("userData", "fluxus_mobile_idVendedor");
  dadosSessao.vendedor_id = vendedorId ? parseInt(vendedorId) : null;

  dadosSessao.vendedor_nome = await descriptografarObjetoSession(
    "userData",
    "fluxus_mobile_nomeVendedor"
  );

  const usuarioId = await descriptografarObjetoSession("userData", "fluxus_mobile_idUsuario");
  dadosSessao.usuario_id = usuarioId ? parseInt(usuarioId) : null;

  const filtros = localStorage.getItem("fluxus_mobile_filtroProdutos");
  if (filtros) dadosSessao.filtros_produto = JSON.parse(filtros);

  dadosSessao.inicio_sessao = sessaoIniciada;
}

export function logAcaoUsuario(acao, detalhes = {}) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    tipo: "ACAO_USUARIO",
    acao,
    detalhes,
  };
  logsHistorico.push(log);
  return log;
}

export function logAdicionarItem(pedido, itemNovo) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    operacao: "ADICIONAR_ITEM",
    total_itens_antes: pedido.itens_pedido.length - 1,
    total_itens_depois: pedido.itens_pedido.length,
    item_adicionado: {
      id: itemNovo.id,
      nome: itemNovo.nome,
      quantidade: itemNovo.quantidade,
      preco: itemNovo.preco,
      preco_tabela: itemNovo.preco_tabela,
      preco_minimo: itemNovo.preco_minimo,
      preco_maximo: itemNovo.preco_maximo,
      ajuste_item: itemNovo.ajuste_item,
      ajuste_percentual: itemNovo.ajuste_percentual,
      mercOuServ: itemNovo.mercOuServ,
      valor_total: formatarMoeda(itemNovo.preco * itemNovo.quantidade),
    },
  };
  logsHistorico.push(log);
  return log;
}

export function logEditarItem(pedido, itemAntes, itemDepois, index) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    operacao: "EDITAR_ITEM",
    index_editado: index,
    item_antes: {
      id: itemAntes.id,
      nome: itemAntes.nome,
      quantidade: itemAntes.quantidade,
      preco: itemAntes.preco,
      preco_tabela: itemAntes.preco_tabela,
      preco_minimo: itemAntes.preco_minimo,
      preco_maximo: itemAntes.preco_maximo,
      ajuste_item: itemAntes.ajuste_item,
      valor_total: formatarMoeda(itemAntes.preco * itemAntes.quantidade),
    },
    item_depois: {
      id: itemDepois.id,
      nome: itemDepois.nome,
      quantidade: itemDepois.quantidade,
      preco: itemDepois.preco,
      preco_tabela: itemDepois.preco_tabela,
      preco_minimo: itemDepois.preco_minimo,
      preco_maximo: itemDepois.preco_maximo,
      ajuste_item: itemDepois.ajuste_item,
      valor_total: formatarMoeda(itemDepois.preco * itemDepois.quantidade),
    },
  };
  logsHistorico.push(log);
  return log;
}

export function logSubstituirItem(pedido, itemAntes, itemDepois, index) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    operacao: "SUBSTITUIR_ITEM",
    index_substituido: index,
    item_removido: { id: itemAntes.id, nome: itemAntes.nome, quantidade: itemAntes.quantidade },
    item_novo: { id: itemDepois.id, nome: itemDepois.nome, quantidade: itemDepois.quantidade },
  };
  logsHistorico.push(log);
  return log;
}

export function logRemoverItem(pedido, itemRemovido, index) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    operacao: "REMOVER_ITEM",
    index_removido: index,
    item_removido: { id: itemRemovido.id, nome: itemRemovido.nome },
  };
  logsHistorico.push(log);
  return log;
}

export function logSelecionarMercadoria(mercadoriaData) {
  if (!geraLogsAtivo) return;
  sequenciaOperacao++;
  const log = {
    timestamp: getTimestamp(),
    timestamp_detalhado: getTimestampDetalhado(),
    sequencia: sequenciaOperacao,
    operacao: "SELECIONAR_MERCADORIA",
    mercadoria_id: mercadoriaData.id,
    mercadoria_nome: mercadoriaData.nome,
    valores_banco: {
      preco_padrao: mercadoriaData.preco_padrao_original,
      preco_maximo: mercadoriaData.preco_maximo_original,
      preco_minimo: mercadoriaData.preco_minimo_original,
    },
    valores_calculados: {
      precoMaximo: mercadoriaData.precoMaximo,
      precoMinimo: mercadoriaData.precoMinimo,
      precoPadrao: mercadoriaData.precoPadrao,
      precoTabela: mercadoriaData.precoTabela,
      precoTabelaAlternativa: mercadoriaData.precoTabelaAlternativa,
    },
    valores_originais: {
      precoMaximoOriginal: mercadoriaData.precoMaximoOriginal,
      precoMinimoOriginal: mercadoriaData.precoMinimoOriginal,
      precoOriginal: mercadoriaData.precoOriginal,
    },
  };
  logsHistorico.push(log);
  return log;
}

export function getLogs() {
  return logsHistorico;
}

export function limparLogs() {
  logsHistorico = [];
  sequenciaOperacao = 0;
  pedidoFinal = null;
}

export async function enviarLogsParaBackend(pedidoId) {
  if (!geraLogsAtivo) {
    return { sucesso: false, mensagem: "Logs desabilitados" };
  }
  if (logsHistorico.length === 0) {
    return { sucesso: false, mensagem: "Sem logs" };
  }

  const pedidoIdNumerico = pedidoId ? parseInt(pedidoId) : null;

  await iniciarSessaoLog();

  const payload = {
    pedido_id: pedidoIdNumerico,
    timestamp_envio: getTimestampDetalhado(),
    total_operacoes: logsHistorico.length,
    sessao: dadosSessao,
    pedido_final: pedidoFinal || null,
    logs: logsHistorico,
  };

  try {
    const hostBackend = process.env.VUE_APP_BACKEND_URL || window.location.origin;
    const response = await postData(`${hostBackend}/api/v1/logs-pedidos`, payload);
    logsHistorico = [];
    sequenciaOperacao = 0;
    return { sucesso: true, resultado: response.data };
  } catch (error) {
    return { sucesso: false, mensagem: error.message };
  }
}

if (typeof window !== "undefined") {
  window.PedidoLogger = {
    getLogs,
    enviar: enviarLogsParaBackend,
    limpar: limparLogs,
    getSessao: () => dadosSessao,
  };
}
